module.exports = __webpack_public_path__ + "img/gb9115_35.prt.46342bcb.jpg";